import { render } from "./NewRate.vue?vue&type=template&id=93072690&scoped=true"
import script from "./NewRate.vue?vue&type=script&lang=js"
export * from "./NewRate.vue?vue&type=script&lang=js"

import "./NewRate.vue?vue&type=style&index=0&id=93072690&scoped=true&lang=css"

import exportComponent from "C:\\Users\\oaromasodun\\Desktop\\MarinePortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93072690"]])

export default __exports__